import axios from '@axios'

export default {
  getPaymentTypes(page, field) {
    return axios.post(`platform/paytypes/list?page=${page}`, field)
  },

}
